import React, { useContext, useState, useEffect } from 'react';
import { Grid, Flexbox, Divider } from '@sede-enterprise/shell-ds-react-framework';
import 'leaflet/dist/leaflet.css';
import { AnalyticsFilterSection } from '../AnalyticsHome/AnalyticsFilterSection';
import DateSideCard from '../AnalyticsHome/DateSideCard/DateSideCard';
import TopCtpyHeader from './TopCtpyHeader/TopCtpyHeader';
import TopCtpyBarChart from './TopCtpyCharts/TopCtpyBarChart/TopCtpyBarChart';
import TopCtpyTable from './TopCtpyCharts/TopCtpyTable/TopCtpyTable';
import { AppContext } from '../../../../Context/AppContext';
import PipelineRunMessageOverlay from '../PipelineRunMessage/PipelineRunMessageOverlay';

export const TopCounterParties = () => {
  const { state: analyticsState, dispatch: analyticsDispatch } =
      useContext(AppContext).analyticsHome;
  const [isTopCtpyChartApiResponseEmpty, setIsTopCtpyChartApiResponseEmpty] = useState(false);
  const [isTopCtpyTableApiResponseEmpty, setIsTopCtpyTableApiResponseEmpty] = useState(false);
  
  useEffect(() => {
    analyticsDispatch({
      type: 'setIsAnyPrimaryApiResponseEmpty',
      payload: isTopCtpyChartApiResponseEmpty ?? isTopCtpyTableApiResponseEmpty,
    });
  }, [analyticsDispatch, isTopCtpyChartApiResponseEmpty, isTopCtpyTableApiResponseEmpty]);
  return (
    <div style={{ height: '100%', background: '#F5F5F5' }} data-testid='top-counter-parties'>
      <Flexbox gap='24px 24px' style={{ marginLeft: '15px', justifyContent: 'start' }}>
        <AnalyticsFilterSection />
        <Grid gap='10px'>
          <Grid.Cell>
            <Flexbox justifyContent='space-between'>
              <TopCtpyHeader />
              <DateSideCard />
            </Flexbox>
          </Grid.Cell>
          <Divider size='medium' direction='horizontal' />
          <Grid.Cell>
            <div style={{ position: 'relative' }}>
              <PipelineRunMessageOverlay show={analyticsState.isAnyPrimaryApiResponseEmpty} />
           <div>
              <TopCtpyBarChart setIsTopCtpyChartApiResponseEmpty={setIsTopCtpyChartApiResponseEmpty} />
            </div>
            <div style={{ marginTop: '10px' }}>
              <TopCtpyTable setIsTopCtpyTableApiResponseEmpty={setIsTopCtpyTableApiResponseEmpty} />
            </div>
            </div>
          </Grid.Cell>
        </Grid>
      </Flexbox>
    </div>
  );
};